import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import icons from '../../../../../constants/icons';
import { useTranslation } from 'react-i18next';

export interface WarningCellProps {
  promotion?: any;
  game?: any;
  editable?: boolean;
}

function WarningCell({ promotion, game, editable }: WarningCellProps) {
  const { t } = useTranslation();
  return (
    <div className="grid-warning">
      <FontAwesomeIcon icon={icons.ARE_YOU_SURE} className="pe-2" />
      {t('Warning message')}
    </div>
  );
}

export default WarningCell;
